import { useTranslation } from 'react-i18next';
import { SearchableSelect } from '@/components/ui/searchableSelect';
import { resolveLocalizedText } from '@/utils/localizedText';
import { PreVisitQuestionLabel } from './PreVisitQuestionLabel';
import type { PreVisitQuestionRendererProps } from './preVisitQuestionRendererProps';

export function SingleChoiceRenderer({ question, value, isInvalid, onChange }: PreVisitQuestionRendererProps) {
  const { t, i18n } = useTranslation('intake');
  const resolvedValue = typeof value === 'string' ? value : '';
  const inputId = 'pre-visit-question-' + question.code;

  return (
    <div className="space-y-1.5">
      <PreVisitQuestionLabel question={question} htmlFor={inputId} />
      <SearchableSelect
        inputId={inputId}
        ariaLabel={resolveLocalizedText(question.labelEn, question.labelPl, i18n.language)}
        placeholder={t('preVisit.choosePlaceholder')}
        hasError={isInvalid}
        value={resolvedValue}
        isClearable
        options={question.options.map(function toOption(option) {
          return {
            value: option.code,
            label: resolveLocalizedText(option.labelEn, option.labelPl, i18n.language),
          };
        })}
        onChange={function change(nextValue) {
          onChange(nextValue);
        }}
      />
    </div>
  );
}
